import type { CSSProperties } from 'react';

// Polygon toolbar icons over the SAME pentagon silhouette (same 5 vertices).
// Straight mode: sharp corners, no nodes. Smooth mode: rounded corners with the
// vertices shown as nodes (a pen/path-tool feel). Stroke-based to sit alongside
// the lucide toolbar icons; color follows `currentColor`.

interface IconProps {
  className?: string;
  style?: CSSProperties;
}

// The five pentagon vertices, shown as nodes on the smooth icon.
const PENTAGON: ReadonlyArray<readonly [number, number]> = [
  [12, 3],
  [20.6, 9.2],
  [17.3, 19.3],
  [6.7, 19.3],
  [3.4, 9.2],
];

// Sharp pentagon — straight edges, hard vertices (miter joins).
export function PolyStraightIcon({ className, style }: IconProps) {
  return (
    <svg
      className={className}
      style={style}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="miter"
    >
      <path d="M12 3 L20.6 9.2 L17.3 19.3 L6.7 19.3 L3.4 9.2 Z" />
    </svg>
  );
}

// Same pentagon, corners rounded into curves, with the vertices drawn as nodes.
export function PolySmoothIcon({ className, style }: IconProps) {
  return (
    <svg
      className={className}
      style={style}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M14.85 5.05 L17.75 7.15 Q20.6 9.2 19.51 12.54 L18.39 15.96 Q17.3 19.3 13.79 19.3 L10.21 19.3 Q6.7 19.3 5.61 15.96 L4.49 12.54 Q3.4 9.2 6.25 7.15 L9.15 5.05 Q12 3 14.85 5.05 Z" />
      {PENTAGON.map(([x, y]) => (
        <circle key={`${x}-${y}`} cx={x} cy={y} r={1.7} fill="currentColor" stroke="none" />
      ))}
    </svg>
  );
}
